import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "./services/i18n";
import { Suspense } from "react";
import Preloader from "./containers/spinners/Preloader";
import { HelmetProvider } from "react-helmet-async";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

/*
  So'rov keshi. Telefonda muhim: sahifalar orasida qatnaganda bir xil
  ma'lumot qayta so'ralavermasin, lekin eskirib ham qolmasin.
*/
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Oyna orqasidan qaytganda har safar qayta so'ramaydi
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000,
    },
  },
})
ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Preloader />}>
        <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

/*
  Service worker — ilova telefonda tez ochilishi va aloqa uzilganda ham
  oyna chiqishi uchun. Faqat ishlab chiqarish yig'masida yoqiladi:
  ishlab chiqish paytida u eski fayllarni ushlab qolib chalkashtirardi.

  API javoblari keshlanmaydi, sahifa esa avval tarmoqdan olinadi —
  shuning uchun yangi versiya kechikmasdan yetadi.
*/
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Ro'yxatdan o'tmasa ilova oddiy holda ishlayveradi
    })
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
